// export { default as store } from "./store/store.vue";
export const store = (r) => require.ensure([], () => r(require("./store/store.vue")), "store");
